export default "__VITE_ASSET__BEqiQXxp__"